import { render, staticRenderFns } from "./TeamEventCreateForm.vue?vue&type=template&id=65594bdb&scoped=true&"
import script from "./TeamEventCreateForm.vue?vue&type=script&lang=ts&"
export * from "./TeamEventCreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./TeamEventCreateForm.vue?vue&type=style&index=0&id=65594bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65594bdb",
  null
  
)

export default component.exports